import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "count", "status"]
  static values = {
    url: String,
    max: { type: Number, default: 10 },
    current: { type: Number, default: 0 }
  }

  connect() {
    this.updateUi(this.currentValue)
  }

  async toggle() {
    if (!this.hasUrlValue || this.currentValue >= this.maxValue) return
    if (this._pending) return
    this._pending = true

    const token = document.querySelector("meta[name='csrf-token']")?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token || "",
          "Accept": "application/json"
        }
      })

      if (!response.ok) return

      const payload = await response.json()
      this.currentValue = Number(payload.count || this.currentValue)
      this.updateUi(this.currentValue)
      this.animatePulse()
    } finally {
      this._pending = false
    }
  }

  updateUi(count) {
    if (this.hasCountTarget) this.countTarget.textContent = String(count)

    const reached = count >= this.maxValue
    if (this.hasButtonTarget) this.buttonTarget.disabled = reached
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = reached ? "Alcanzaste el máximo de aplausos" : "Haz clic para alentar"
    }
  }

  animatePulse() {
    this.element.classList.remove("aplauso-counter--animating")
    requestAnimationFrame(() => {
      this.element.classList.add("aplauso-counter--animating")
      setTimeout(() => this.element.classList.remove("aplauso-counter--animating"), 500)
    })
  }
}
